/**
 * The initial values for the redux state.
 */
export default {
  timestamp: 0,
  resId: 0,

  model: {
    transport_type: 1, // OWN_TEAM
    code: '',
    desc_01: '',
    desc_02: ''
  },

  modelIsLoading: false,

  locationOptions: [],
  locationIsLoading: false
};
